/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

export interface IShipMultipleAddressesTableHeadingProps {
    selectAllRowsText?: string;
    productNumber: string;
    productName: string;
    productUnitPrice: string;
    productQuantity: string;
    clickHandler(isChecked: boolean): void;
    productImage?: string;
    productAddress?: string;
    isAllSelected: boolean;
    isMobile: boolean;
    clearSelectionButton: React.ReactNode;
}

export interface IShipMultipleAddressesTableHeadingState {
    isChecked: boolean;
}

export interface IShipMultipleAddressesTableShortHeading {
    productNumber: string;
    productActions: string;
}

/**
 * Ship multiple addresses table heading.
 */
export class ShipMultipleAddressesTableHeading extends React.PureComponent<IShipMultipleAddressesTableHeadingProps> {
    public state: IShipMultipleAddressesTableHeadingState = {
        isChecked: false
    };

    private readonly componentClassName: string = 'ms-table';

    public getOnChange = () => (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState(
            {
                isChecked: !this.state.isChecked
            },
            () => {
                this.props.clickHandler(this.state.isChecked);
            }
        );
    };

    public render(): JSX.Element {
        if (!this.props.isMobile) {
            return (
                <thead>
                    <tr className={`${this.componentClassName}__heading-row`}>
                        <th scope='col' aria-label={this.props.selectAllRowsText}>
                            <label className='checkbox-container'>
                                <input
                                    aria-label={this.props.selectAllRowsText}
                                    className='checkbox-input'
                                    type='checkbox'
                                    aria-checked={this.props.isAllSelected}
                                    checked={this.props.isAllSelected}
                                    onChange={this.getOnChange()}
                                />
                                <span className='checkmark' />
                            </label>
                        </th>
                        <th scope='col'>{this.props.productNumber}</th>
                        {<th scope='col'>{this.props.productName}</th>}
                        {
                            <th scope='col' style={{ textAlign: 'right' }}>
                                {this.props.productUnitPrice}
                            </th>
                        }
                        {
                            <th scope='col' style={{ textAlign: 'center' }}>
                                {this.props.productQuantity}
                            </th>
                        }
                        {<th scope='col'>{this.props.productAddress}</th>}
                    </tr>
                </thead>
            );
        } else {
            return (
                <thead>
                    <tr className={`${this.componentClassName}__heading-row`}>
                        <th scope='col' style={{ maxWidth: '100px', position: 'relative' }} aria-label={this.props.selectAllRowsText}>
                            <label className='checkbox-container' style={{ paddingLeft: '25px' }}>
                                <input
                                    aria-label={this.props.selectAllRowsText}
                                    className='checkbox-input'
                                    type='checkbox'
                                    aria-checked={this.props.isAllSelected}
                                    checked={this.props.isAllSelected}
                                    onChange={this.getOnChange()}
                                />
                                <span className='checkmark' style={{ border: '1.5px solid #2266e3' }} />
                                Select all
                            </label>

                            {/* Clear Selection Button */}
                            <div style={{ position: 'absolute', top: '50%', left: '65%', transform: 'translate(-50%, -50%)' }}>
                                {this.props.clearSelectionButton}
                            </div>
                        </th>
                    </tr>
                </thead>
            );
        }
    }
}
